module.exports = __webpack_public_path__ + "static/media/client_detail_img4.767e86df.jpg";